import { Domain } from "assets/lib/config";
import axios from "axios";

export const uploadFile = (file, id) => {
  return new Promise(async (resolve, reject) => {
    try {
      let options = {
        "Content-type": "application/json",
        Accept: "*/*",
        "Accept-Encoding": "gzip, deflate, br",
        Connection: "keep-alive",
      };
      let formData = new FormData();
      formData.append("signature", file)
      formData.append("requestID", id)

      let s3Upload = await axios.post(
        `${Domain}/api/html/uploadSignature`,
        formData,
        options
      );
      // let s3Upload = await axios.post(
      //   `${Domain}/api/html/getURL`,
      //   {
      //     requestID: id.toString(),
      //     type: file.type,
      //   },
      //   options
      // );
      // await S3Upload(file, s3Upload.data.result.postUrl).catch((err) => {
      //   throw err;
      // });
      return resolve(s3Upload);
    } catch (e) {
      return reject(e);
    }
  });
};

// const S3Upload = (file, putURL) => {
//   return new Promise(async (resolve, reject) => {
//     try {
//       let s3Upload = await axios.put(putURL, file);
//       return resolve(s3Upload);
//     } catch (e) {
//       return reject(e);
//     }
//   });
// };
